var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      staticClass: "errorSnackBar",
      attrs: {
        value: _vm.hasError,
        color: "error",
        vertical: "",
        "multi-line": "",
        bottom: ""
      },
      on: { input: _vm.close }
    },
    [
      _vm._l(_vm.errors, function(error, index) {
        return _c("div", { key: error }, [
          index > 0 ? _c("p", [_vm._v("\n      -\n    ")]) : _vm._e(),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(error))])
        ])
      }),
      _vm._v(" "),
      _c(
        "v-btn",
        {
          attrs: { dark: "", flat: "" },
          on: {
            click: function($event) {
              return _vm.close(false)
            }
          }
        },
        [_vm._v("\n    Close\n  ")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/ApiErrors.vue?vue&type=template&id=7cc9b7a5&
// module id = null
// module chunks = 